<app-column label="Labels" [loading]="!interactive">
  <div column-actions>
    <button
      app-button
      [matMenuTriggerFor]="labelMenu"
      class="context__actions">
      <fa-icon icon="ellipsis-v"></fa-icon>
    </button>

    <mat-menu #labelMenu="matMenu">
      <button mat-menu-item (click)="handleRemoveAll()">Remove all labels</button>
      <mat-divider></mat-divider>
      <button mat-menu-item [matMenuTriggerFor]="convertStoryMenu">Convert all labels</button>
      <button mat-menu-item [matMenuTriggerFor]="convertChapterMenu">Convert this chapter's labels</button>
    </mat-menu>

    <mat-menu #convertStoryMenu="matMenu">
      <button mat-menu-item (click)="handleConvertLabels(labelRecipe.Annotation, 'story')">Dark (Classic)</button>
      <button mat-menu-item (click)="handleConvertLabels(labelRecipe.StudioNext, 'story')">Light</button>
    </mat-menu>
    
    <mat-menu #convertChapterMenu="matMenu">
        <button mat-menu-item (click)="handleConvertLabels(labelRecipe.Annotation, 'chapter')">Dark (Classic)</button>
        <button mat-menu-item (click)="handleConvertLabels(labelRecipe.StudioNext, 'chapter')">Light</button>
      </mat-menu>
  </div>

  <!-- Chapters -->
  <app-column-group label="Label">
    <ng-container column-group-header>
      <app-conversion-alert class="mb-2"></app-conversion-alert>

      <div class="pl-2">
        <mat-checkbox
          [checked]="lockCamera$ | async" 
          (change)="handleCheckedChange($event)">
          <span class="text-12">Disable label zoom while editing</span>
        </mat-checkbox>
      </div>
    </ng-container>
    
    <ng-container column-group-body>
  
      <!-- Null state -->
      <div class="p-3" *ngIf="!(labels$ | async)?.length">
        <div class="text-12 text-bold">Add a label</div>
        <div class="text-12">Click on an object in the 3D scene to start adding labels.</div>
      </div>
  
      <!-- Labels -->
      <app-label-widget
        *ngFor="let label of (labels$ | async); trackBy: trackLabel"
        [attr.data-id]="label.id"
        [label]="label"
        [open]="(selectedLabel$ | async)?.id === label.id"
        (opened)="handleOpened($event)"></app-label-widget>
    </ng-container>
  </app-column-group>
  
</app-column>

